import React from "react";
import logo from "@/assets/brand/ei-battery-logo.png";

// Approved master logo. Navy wordmark must sit on a warm-white / light surface only.
export default function Logo({ className = "", width = 290 }) {
  return (
    <img
      src={logo}
      alt="EI Battery"
      width={width}
      style={{ width: `${width}px`, height: "auto", display: "block" }}
      className={className}
      data-testid="ei-logo"
    />
  );
}
